import restapp from '../api/restapp';

import {
  CV_MODEL_UPDATE,
  CV_MODEL_UPDATE_2,
  CV_MODEL_UPDATE_COLOR,
  CV_MODEL_UPDATE_FONT
} from './types';

const initialState = {
  vuexCvModel: {},
};


const getters = {
  getTemplates: state => {
    console.log("------ GETTER cvVuex getTemplates -------");
    console.log('les templates : ' + state.vuexCvModel.templates);
    return state.vuexCvModel.templates;
  },
  getDefaultTemplate: state => {
    // retourne l'id du cv_template par défaut associé au CV
    console.log("------ GETTER cvVuex getDefaultTemplate -------");
    console.log('template par defaut : ');
    console.log(state.vuexCvModel.cv_template);
    return state.vuexCvModel.cv_template;
    // console.log(state.vuexCvModel.templates.filter(temp => temp.template == def_template ));
    // return state.vuexCvModel.templates.filter(temp => temp.template == def_template );
  },
  getRelatedTemplate: state => {
    // retourne l'objet curritemplate associé au CV.
    console.log("------ GETTER cvVuex getRelatedTemplate -------");
    var templates = state.vuexCvModel.templates;
    // console.log('Tous les templates : ');
    // console.log(templates);
    var defTemplate = state.vuexCvModel.cv_template.id;
    // console.log('Template ID par défaut : ' + defTemplate);
    var theTemplate = templates.filter(temp => temp.template == defTemplate);
    console.log('Objet getRelatedTemplate : ');
    console.log(theTemplate[0]);
    return theTemplate[0];
  },
  getCvName: state => {
    // retourne le nom du cv
    console.log("------ GETTER cvVuex getCvName -------");
    return state.vuexCvModel.name;
  }
};

const actions = {
  getCvModelObject({ commit }, { cvid }) {
    console.log('**** VUEX cvVuex getCvModelObject called: ' + cvid);
    return restapp.getCvObj(cvid)
      .then(({ data }) => commit(CV_MODEL_UPDATE, data))
      .catch(function (error) {
        if (error.response) {
          console.log(error);
        }
        else if (error.request) {
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
          // http.ClientRequest in node.js
          console.log(error.request);
        }
        else {
          // Something happened in setting up the request that triggered an Error
          console.log('Error get', error.message);
        }
        console.log(error.config);
      });
  },

  updateCvModelObject({ commit }, { cvid, data_sent }) {
    // appelle restapp.patchCvObj
    // Passe uniquement une partie des propriété de l'objet à patch
    console.log('**** VUEX cvVuex updateCvModelObject called: ' + cvid);
    this.isLoading = true;
    console.log("Changement sur l'objet : " + cvid);
    console.log('data_sent : ');
    console.log(data_sent);

    return restapp.patchCvObj(cvid, data_sent)
      .then(({ data }) => commit(CV_MODEL_UPDATE, data))
      .catch(function (error) {
        if (error.response) {
          console.log(error);
        }
        else if (error.request) {
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
          // http.ClientRequest in node.js
          console.log(error.request);
        }
        else {
          // Something happened in setting up the request that triggered an Error
          console.log('Error update', error.message);
        }
        console.log(error.config);
      });
  },
};

const mutations = {
  [CV_MODEL_UPDATE](state, resp) {
    console.log('VUEX cvVuex : data sent to mutation CV_MODEL_UPDATE : ');
    console.log(resp);
    state.vuexCvModel = resp;
  },
  [CV_MODEL_UPDATE_2](state, struct) {
    // mutation dédiée au getter/setter (voir le composant CvEdit.vue)
    console.log('VUEX cvVuex [CV_MODEL_UPDATE_2] : données envoyée à la mutation 2 : ');
    console.log(struct);
    console.log('****AVT* : ');
    console.log(state.vuexCvModel);
    // https://developer.mozilla.org/fr/docs/Web/JavaScript/Reference/Objets_globaux/Object/assign
    // https://stackoverflow.com/questions/12534238/updating-javascript-object-attributes-from-another-object
    Object.assign(state.vuexCvModel, struct);
    console.log('****APR* : ');
    console.log(state.vuexCvModel);
  },
  [CV_MODEL_UPDATE_COLOR](state, color) {
    console.log('VUEX cvVuex [CV_MODEL_UPDATE_COLOR] : données envoyée à la mutation : ');
    console.log(color);
    var def_template = state.vuexCvModel.cv_template.id;
    var index = state.vuexCvModel.templates.findIndex(x => x.template === def_template);
    state.vuexCvModel.templates[index].cv_color1 = color;
    // Object.assign(state.vuexCvModel.templates, allTemplates);
  },
    [CV_MODEL_UPDATE_FONT](state, font) {
    console.log('VUEX cvVuex [CV_MODEL_UPDATE_FONT] : données envoyée à la mutation : ');
    console.log(font);
    var def_template = state.vuexCvModel.cv_template.id;
    var index = state.vuexCvModel.templates.findIndex(x => x.template === def_template);
      state.vuexCvModel.templates[index].cv_font1 = font;
    },
};

export default {
  namespaced: true,
  state: initialState,
  actions,
  mutations,
  getters
};
